import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, Upload, Wand2, Download, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: Sparkles, title: "Pick your product", desc: "Browse coloring books, storybooks and keepsakes. Choose the one that fits the person and the moment." },
  { icon: Upload, title: "Upload your memories", desc: "Answer a few personalization questions and upload clear, well-lit photos where faces are visible." },
  { icon: Wand2, title: "We create the magic", desc: "Our studio transforms your photos and details into a beautifully crafted keepsake." },
  { icon: Download, title: "Download your keepsake", desc: "Get an email when it's ready and download your printable PDF straight from your account." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14">
      <div className="text-center max-w-2xl mx-auto">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-slateink">How It Works</h1>
        <p className="text-slate-600 mt-4 text-lg">From photo to finished keepsake — entirely online, no calls or consultations needed.</p>
      </div>
      <div className="mt-14 space-y-6">
        {STEPS.map((s, i) => (
          <div key={i} className="flex gap-5 bg-white rounded-2xl p-6 border border-slate-100">
            <div className="w-14 h-14 rounded-2xl bg-amber-100 text-amber flex items-center justify-center shrink-0"><s.icon className="w-7 h-7" /></div>
            <div>
              <p className="text-xs font-bold text-amber-700/60">STEP {i + 1}</p>
              <h3 className="font-display text-xl font-bold text-slateink mt-0.5">{s.title}</h3>
              <p className="text-slate-600 mt-1.5 leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-12">
        <Button asChild size="lg" className="rounded-full bg-amber hover:bg-amber-600 text-white font-semibold h-12 px-8"><Link to="/shop">Create My Book <ArrowRight className="w-4 h-4 ml-1" /></Link></Button>
      </div>
    </div>
  );
}
